import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ReactComponent as ArrowIcon } from "assets/icons/left-arrow.svg";
import "./payment-styles.css";

const PaymentFailure = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const paymentId =
    searchParams.get("collection_id") || searchParams.get("payment_id");

  return (
    <article className="container-payments-centered">
      <section className="form-container">
        <div className="payment-receipt-card">
          <div className="payment-header-status">
            <h2>Pago No Aprobado</h2>
            <p>
              El pago no pudo ser procesado o fue rechazado por la entidad
              financiera.
            </p>
          </div>

          <div className="receipt-details">
            <p>
              <strong>N° de Referencia:</strong> {paymentId || "N/A"}
            </p>
            <p>
              <strong>Estado:</strong> RECHAZADO
            </p>
          </div>

          <button className="btn-back-step" onClick={() => navigate(-1)}>
            <ArrowIcon />
            Intentar nuevamente
          </button>
        </div>
      </section>
    </article>
  );
};

export default PaymentFailure;
